<template>
  <div>
    <div class="header-wrap">
      <img src="@/assets/images/header-bg.png" alt="" />
      <div v-if="noLogin" class="btn-box">
        <button class="login-btn" @click="slogin">个人登录</button>
        <button class="login-btn" @click="flogin">法人登录</button>
      </div>
      <div v-else class="btn-box">
        <div class="nickname" @click="gotoUser">Hi {{ nickName }}</div>
        <div class="logout" @click="logout">退出</div>
      </div>
    </div>
    <div class="nav-wrap">
      <ul class="nav">
        <li v-for="item in navList" :key="item.title" :class="{ active: title === item.title }" class="nav-item pointer" @click="handleGoPage(item)">
          <div>{{ item.title }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalHeader',
  data() {
    return {
      navList: [
        {
          title: '首页',
          link: '/',
        },
        {
          title: '政策查询',
          link: '/policy-inquiries',
        },
        {
          title: '服务超市',
          link: '/service-market',
        },
        {
          title: '人才招聘',
          outlink: 'https://ycyg.nbhr.org.cn/',
        },
        {
          title: '人才工程',
          outlink: 'http://rcgc.nbrc.com.cn/#/Home',
        },
        {
          title: '揭榜挂帅',
          outlink: 'https://rcgj.zj.gov.cn:7005/pc/index/',
        },
        {
          title: '人才活动',
          link: '/talent-activities',
        },
        {
          title: '服务诉求',
          link: '/service',
        },
        // {
        //   title: '人才科技周',
        //   outlink: 'https://nbrc.gov.cn/rckjzScreen/#/',
        // },
      ],
    }
  },
  computed: {
    nickName() {
      return this.$store.state.userInfo.nickname
    },
    noLogin() {
      return !this.$store.state.userInfo.nickname
    },
    title() {
      return this.$route.meta.title
    },
  },
  watch: {
    $route(val) {
      console.log(val)
    },
  },
  methods: {
    gotoUser() {
      if (checkLogin()) {
        this.$router.push({
          path: '/user',
        })
      }
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        window.location.reload()
      })
      // let iframe = document.createElement('iframe')
      // iframe.src = 'https://portal.zjzwfw.gov.cn/uc/unifiedLogout'
      // iframe.style = 'position:fixed;left:-9999px;top:-9999px'
      // document.body.append(iframe)
      // setTimeout(() => {
      //   document.body.removeChild(iframe)
      // }, 200)
      let a = window.open('https://portal.zjzwfw.gov.cn/uc/unifiedLogout', '_blank')
      setTimeout(() => {
        a.close()
      }, 300)
    },
    slogin() {
      window.open('https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330201271550202305000005_1&sp=' + encodeURI(this.$route.fullPath), '_self')
    },
    flogin() {
      window.open('https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330201271550202305000005_2&sp=' + encodeURI(this.$route.fullPath), '_self')
    },
    handleGoPage(item) {
      if (item.link) {
        this.$router.push(item.link)
      } else if (item.outlink) {
        window.open(item.outlink)
      }
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .header-wrap {
    position: relative;
    img {
      width: 100vw;
    }
    .btn-box {
      position: absolute;
      right: 10%;
      top: 50%;
    }
    .nickname {
      color: #1b5bfa;
      font-size: 20px;
      font-weight: bold;
      display: inline-block;
    }
    .logout {
      color: #1b5bfa;
      font-size: 20px;
      font-weight: bold;
      display: inline-block;
      margin-left: 20px;
      cursor: pointer;
    }
    .login-btn {
      margin-left: 20px;
      background-image: linear-gradient(110deg, #5787ff, #1b5bfa, #5787ff, #1b5bfa);
      box-shadow: 0px 0.1563vw 0.5208vw 0px rgba(30, 194, 203, 0.53);
      border-radius: 0.3573vw;
      padding: 0.6597vw 2.2569vw;
      font-size: 16px;
      line-height: 1.2em;
      border: none;
      background-size: 200% 100%;
      background-position: 0 0;
      transform: translateY(-50%);
      transition: all var(--transition-duration);
      &:active {
        box-shadow: 0px 0.1563vw 0.5208vw 0px rgba(30, 194, 203, 0.53) inset;
      }
      &:hover {
        background-position: 100% 0;
      }
    }
  }
  .nav-wrap {
    height: 60px;
    min-height: 50px;
    background-color: #868c9b;

    .nav {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 1.3889vw;
      font-weight: 600;
      padding: 0 8.3333vw;
      background-size: 100% 200%;
      background-image: linear-gradient(180deg, #1b5bfa, #1b5bfa, rgba(141, 255, 253, 0.3), rgba(85, 255, 250, 0.04));
      .nav-item {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-top: 0.2778vw rgba(141, 255, 253, 0) solid;
        height: 100%;
        flex: 1;
        text-align: center;
        background-image: linear-gradient(180deg, #1b5bfa, #1b5bfa, rgba(141, 255, 253, 0.3), rgba(85, 255, 250, 0.04));
        background-size: 100% 200%;
        transition: all var(--transition-duration);
        background-position: 0 0;
        a {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:hover,
        &.active {
          background-position: 0 100%;
          border-top: 0.2778vw rgba(141, 255, 253, 0.6) solid;
        }
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
